<template>
    <div>
        <apexchart
            type="bar"
            height="640"
            :options="chartOptions"
            :series="series">
        </apexchart>
    </div>
</template>

<script>
export default {
    props: {
        chartData: {
            type: [Array, Object],
            default: () => [],
            required: true,
        },
        title: String,
        horizontal: Boolean,
        colors: {
            type: Array,
            default: () => ['#795BF3'],
        },
        showLegend: Boolean,
    },
    computed: {
        series() {
            if (Array.isArray(this.chartData)) {
                return [
                    {
                        name: this.title,
                        data: this.chartData.map(item => {
                            const keys = Object.keys(item);
                            if (keys.length >= 2) {
                                return { x: item[keys[0]], y: item[keys[1]] };
                            } else if (keys.length === 1) {
                                return { x: keys[0], y: item[keys[0]] };
                            }
                            return { x: '', y: 0 };
                        }),
                    },
                ];
            } else if (this.chartData && typeof this.chartData === 'object') {
                return [
                    {
                        name: this.title,
                        data: Object.entries(this.chartData).map(([key, value]) => ({
                            x: key,
                            y: value,
                        })),
                    },
                ];
            }
            return [];
        },
        chartOptions() {
            let categories = [];
            if (Array.isArray(this.chartData)) {
                categories = this.chartData.map(item => {
                    const keys = Object.keys(item);
                    return keys.length ? item[keys[0]] : '';
                });
            } else if (this.chartData && typeof this.chartData === 'object') {
                categories = Object.keys(this.chartData);
            }

            const options = {
                chart: {
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        horizontal: this.horizontal,
                        barHeight: '75%',
                        distributed: true,
                    }
                },
                dataLabels: {
                    enabled: true,
                    offsetX: this.horizontal ? 50 : 0,
                    offsetY: this.horizontal ? -0.5 : 0,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        colors: ['#fff']
                    },
                    background: {
                        enabled: true,
                        foreColor: '#795BF3',
                        color: '#fff',
                        padding: 4,
                        opacity: 1,
                        borderColor: '#795BF3'
                    },
                },
                legend: {
                    show: this.showLegend,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    fontSize: '14px'
                },
                colors: this.colors
            };

            if (this.horizontal) {
                options.yaxis = {
                    categories: categories,
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                };
            } else {
                options.xaxis = {
                    categories: categories,
                };
            }

            return options;
        }
    }
};
</script>
